/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Molmo = ({ color = 'primary', aspectRatio = '750/137', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Molmo" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Molmo, Molmo as default };
